import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { CashierSuccessView } from '../shared/CashierSuccessView'

export interface RewardRestoreResult {
  restoreCount: number
  rewardName: string
  memberFullName: string
  memberFirstName: string
  newCount: number
}

interface RewardRestoreSuccessViewProps {
  result: RewardRestoreResult
  onScanNext: () => void
  onDone: () => void
}

export function RewardRestoreSuccessView({ result, onScanNext, onDone }: RewardRestoreSuccessViewProps) {
  const { t } = useTranslation()
  const { restoreCount, rewardName, memberFullName, memberFirstName, newCount } = result

  const restoredLabel = restoreCount === 1
    ? t('rewardRestore.success.rewardSingle', { name: rewardName, fullName: memberFullName })
    : t('rewardRestore.success.rewards', { count: restoreCount, name: rewardName, fullName: memberFullName })

  const newTotalLabel = newCount === 1
    ? t('rewardRestore.success.newTotalSingle', { firstName: memberFirstName })
    : t('rewardRestore.success.newTotal', { firstName: memberFirstName, count: newCount })

  return (
    <CashierSuccessView
      title={t('rewardRestore.success.title')}
      scanNextLabel={t('rewardRestore.success.scanNext')}
      doneLabel={t('rewardRestore.success.done')}
      onScanNext={onScanNext}
      onDone={onDone}
    >
      <Text className="text-base lg:text-lg text-secondary text-center">
        {restoredLabel}
      </Text>

      <Text className="text-base lg:text-lg text-secondary text-center">
        {newTotalLabel}
      </Text>
    </CashierSuccessView>
  )
}